import { Footer } from "../../components/Footer";
import { Meta } from "../../components/Meta";
import { VictoryDetail } from "../../components/VictoryDetail";
import { getVictoryBySlug, getVictorySlugs } from "../../lib/getVictory";

export default function Vitorias({ victory }) {
    return <>
        <Meta
            title={victory.title}
            socialTitle={victory.social_title}
            description={victory.social_description}
            pageType={"article"}
            image={victory.thumbnail_url}
            createdAt={victory.created_at}
        />
        <VictoryDetail {...victory} />
        <footer><Footer /></footer>
    </>
}


export async function getStaticProps({ params }) {
    const res = await getVictoryBySlug(params.slug)
    if (res.status === 404) {
        return {
            notFound: true,
        }
    }

    const { victory } = res
    return { props: { victory }, revalidate: 10 }
}

export async function getStaticPaths() {
    const res = await getVictorySlugs()

    if (res.status > 500) {
        return {
            paths: { params: { slug: "" }, fallback: true }
        }
    }

    const paths = res.victories.data.map((victory) => ({
        params: { slug: victory.slug },
    }))
    return { paths, fallback: 'blocking' }
}